module.exports = __webpack_public_path__ + "static/media/Inoculation Info.8ba8f130.png";